module.exports = __webpack_public_path__ + "static/media/content-1@768.bdfe85f8.png";